import _typeof from "@babel/runtime/helpers/typeof";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children"];
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
import PropTypes from 'prop-types';
import AsyncSelect from 'react-select/async';
import { components } from 'react-select';
import ModalTrigger from '../common/ModalTrigger';
import { putRequest } from '../../requestUtils';
var formatError = function formatError(error) {
  return error ? /*#__PURE__*/React.createElement("p", {
    className: "error-text"
  }, error) : '';
};
function MenuList(_ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(components.MenuList, props, Array.isArray(children) ? children.slice(0, 10) : children);
}
var DiseaseCodeMerge = /*#__PURE__*/function (_React$Component) {
  function DiseaseCodeMerge(props) {
    var _this;
    _classCallCheck(this, DiseaseCodeMerge);
    _this = _callSuper(this, DiseaseCodeMerge, [props]);
    _this.state = {
      diseaseCodes: props.diseaseCodes || []
    };
    _this.handleSubmit = _this.handleSubmit.bind(_this);
    _this.handleSelect = _this.handleSelect.bind(_this);
    return _this;
  }
  _inherits(DiseaseCodeMerge, _React$Component);
  return _createClass(DiseaseCodeMerge, [{
    key: "diseaseCodeOptions",
    value: function diseaseCodeOptions() {
      var term = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var mergeDiseaseCodeId = this.props.mergeDiseaseCodeId;
      var diseaseCodes = this.state.diseaseCodes;

      // diseaseCodes is expected to be an array of [name, id] pairs or
      // an array of objects with { label, value }.
      var toOption = function toOption(entry) {
        if (Array.isArray(entry)) {
          var _entry = _slicedToArray(entry, 2),
            name = _entry[0],
            id = _entry[1];
          return {
            label: name,
            value: id
          };
        }
        if (entry && _typeof(entry) === 'object') {
          if ('label' in entry && 'value' in entry) return entry;
          if ('name' in entry && 'id' in entry) return {
            label: entry.name,
            value: entry.id
          };
        }
        return null;
      };
      var normalizedTerm = (term || '').toString().toLowerCase().trim();
      var options = (diseaseCodes || []).map(toOption).filter(Boolean).filter(function (opt) {
        return opt.value !== mergeDiseaseCodeId;
      }).filter(function (opt) {
        if (!normalizedTerm) return true;
        var labelLower = (opt.label || '').toLowerCase().trim();
        var matches = labelLower.includes(normalizedTerm);
        return matches;
      }).slice(0, 50);
      return Promise.resolve(options);
    }
  }, {
    key: "handleSelect",
    value: function handleSelect(val) {
      this.setState({
        selectedDiseaseCode: val
      });
    }
  }, {
    key: "handleSubmit",
    value: function handleSubmit() {
      var _this2 = this;
      var _this$props = this.props,
        mergeDiseaseCodeId = _this$props.mergeDiseaseCodeId,
        csrfToken = _this$props.csrfToken;
      var selectedDiseaseCode = this.state.selectedDiseaseCode;
      putRequest('/disease_codes/merge', {
        to_keep_id: selectedDiseaseCode.value,
        to_merge_id: mergeDiseaseCodeId
      }, csrfToken).then(function () {
        // Redirect to the target disease code (the one we merged into)
        window.location = "/disease_codes/".concat(selectedDiseaseCode.value);
      })["catch"](function (error) {
        var _error$response, _error$response$data;
        console.error('Merge failed:', error);
        _this2.setState({
          error: ((_error$response = error.response) === null || _error$response === void 0 ? void 0 : (_error$response$data = _error$response.data) === null || _error$response$data === void 0 ? void 0 : _error$response$data.error) || 'Merge failed'
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var _this$props2 = this.props,
        diseaseCodeName = _this$props2.diseaseCodeName,
        propError = _this$props2.error;
      var _this$state = this.state,
        selectedDiseaseCode = _this$state.selectedDiseaseCode,
        stateError = _this$state.error;
      var error = stateError || propError;
      return /*#__PURE__*/React.createElement(ModalTrigger, {
        triggerText: "Merge: ".concat(diseaseCodeName, ".."),
        buttonStyles: "secondary",
        submitButtonText: "Merge",
        cancelButtonText: "Cancel",
        handleSubmit: this.handleSubmit,
        closeAfterSubmit: true,
        idKey: "merge-disease-code-modal"
      }, /*#__PURE__*/React.createElement("h2", null, "Merge ".concat(diseaseCodeName, " into ").concat((selectedDiseaseCode === null || selectedDiseaseCode === void 0 ? void 0 : selectedDiseaseCode.label) || '')), /*#__PURE__*/React.createElement("div", {
        id: "disease-code-dropdown",
        className: "disease-code-select",
        role: "button",
        tabIndex: 0
      }, /*#__PURE__*/React.createElement(AsyncSelect, {
        id: "disease-code",
        className: "disease-code-select-dropdown ".concat(error ? 'error' : ''),
        name: "target_disease_code",
        classNamePrefix: "disease-code-select",
        loadOptions: function loadOptions(input) {
          return _this3.diseaseCodeOptions(input);
        },
        defaultOptions: true,
        placeholder: "Target Disease Code Name",
        onChange: this.handleSelect,
        value: selectedDiseaseCode,
        components: {
          MenuList: MenuList,
          IndicatorSeparator: function IndicatorSeparator() {
            return null;
          }
        }
      }), formatError(error)), /*#__PURE__*/React.createElement("div", {
        className: "merge-warning"
      }, /*#__PURE__*/React.createElement("p", {
        className: "text-warning"
      }, /*#__PURE__*/React.createElement("strong", null, "Warning:"), ' ', "This action cannot be undone. All projects, consultant profiles, and other references to \"", diseaseCodeName, "\" will be updated to point to the target disease code.")));
    }
  }]);
}(React.Component);
DiseaseCodeMerge.propTypes = {
  error: PropTypes.string,
  diseaseCodeName: PropTypes.string.isRequired,
  mergeDiseaseCodeId: PropTypes.number.isRequired,
  csrfToken: PropTypes.string.isRequired,
  diseaseCodes: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])))
};
DiseaseCodeMerge.defaultProps = {
  error: null,
  diseaseCodes: []
};
export default DiseaseCodeMerge;